<template>
  <div>
    <kinesis-container event="scroll" class="perspective-container">
      <div class="orbit-container">
        <kinesis-element
          class="sun"
          transformOrigin="center"
          type="rotate"
          :strength="100"
          tag="img"
          :src="sun"
        >
        </kinesis-element>
        <kinesis-element
          class="earthmoon"
          transformOrigin="-40px"
          type="rotate"
          :strength="800"
          tag="div"
        >
          <img class="earth" :src="earth" alt="" />
          <kinesis-element
            class="moon"
            transformOrigin="-30px"
            type="rotate"
            :strength="1200"
            tag="img"
            :src="moon"
          >
          </kinesis-element>
        </kinesis-element>
        <kinesis-element
          class="mars"
          transformOrigin="-175px"
          type="rotate"
          :strength="500"
          tag="img"
          :src="mars"
        >
        </kinesis-element>
      </div>
    </kinesis-container>
    <div class="credits">
      <a href="https://www.flaticon.com/free-icon/sunny_890347" target="_blank"
        >Sun</a
      >
      <a href="https://www.flaticon.com/packs/space-elements" target="_blank"
        >Planets &amp; Moon</a
      >
    </div>
  </div>
</template>

<script>
import { KinesisContainer } from "vue-kinesis";
import { KinesisElement } from "vue-kinesis";
import sun from "@/assets/sun.svg";
import earth from "@/assets/earth.svg";
import moon from "@/assets/moon.svg";
import mars from "@/assets/mars.svg";
export default {
  components: {
    KinesisContainer,
    KinesisElement
  },
  data() {
    return {
      sun,
      earth,
      moon,
      mars
    };
  }
};
</script>

<style lang="scss" scoped>
.orbit-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.perspective-container {
  padding: 200px 0;
}

.sun {
  width: 80px;
  height: 80px;
}

.earth {
  width: 30px;
  height: 30px;
  margin-left: 30px;
}

.moon {
  width: 15px;
  height: 15px;
  margin-left: 20px;
}

.earthmoon {
  display: flex;
  align-items: center;
  left: calc(50% + 40px);
  position: absolute;
}

.mars {
  width: 25px;
  height: 25px;
  margin-left: 30px;
  left: calc(50% + 135px);
  position: absolute;
}
// .celestial {
//   position: absolute;
//   padding: 30px;
// }
// .center {
//   width: 80px;
//   height: 80px;
//   display: inline-block;
// }

// .earth {
//   width: 50px;
//   height: 50px;
// }

// .moon {
//   position: absolute;
//   width: 20px;
//   height: 20px;
//   padding: 30px;
// }

.credits {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.credits a {
  color: white;
  text-decoration: none;
  font-size: 12px;
}

.credits a:hover {
  text-decoration: underline;
}
</style>
